import React, { useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector, } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { isLoaded, useFirestoreConnect } from 'react-redux-firebase'
import { updateFavoriteCountry, setComment, getSpecificUser } from '../store/actions/apiActions'
import gameActions from '../store/actions/gameActions'
import AnimationLayout from '../components/AnimationLayout'
import MatildeBalloon from '../components/MatildeBalloon'
import { EmojiButton } from '../components/ReactionIcons'
import Loading from '../components/Loading'
import Button from '../components/Button'

import moment from 'moment'
import 'moment/locale/pt'
moment.locale('pt')

const rounded = num => {
    if (num > 1000000000) {
        return Math.round(num / 100000000) / 10 + "Bn";
    } else if (num > 1000000) {
        return Math.round(num / 100000) / 10 + "M";
    } else {
        return Math.round(num / 100) / 10 + "K";
    }
}

const TravelDestiny = () => {
    const [state, setState] = useState({
        isOpen: false,
        comment: null,
        comments: null,
        capital: '',
        region: ''
    })

    const dispatch = useDispatch()
    const commentsRef = useRef(null)
    const getReactionItems = useSelector(state => state.firebase.profile.reactionItems)
    const chapters = useSelector(state => state.game.currentNarrativeObject.narratives)
    const countryName = useSelector(state => state.game.currentNarrativeObject.country)
    const updatingReaction = useSelector(state => state.apiCalls.updatingReactions)
    const country = useSelector(state => state.apiCalls.apiData.country)
    const profile = useSelector(state => state.firebase.profile)
    const countryDoc = useSelector(state => state.firestore.data['country'])
    useFirestoreConnect(() => [{ collection: 'countries', doc: countryName, storeAs: 'country' }])
    const isCountryFavorite = profile.favoriteCountries ? profile.favoriteCountries.find(item => item.name === countryName) : false
    const currentLocation = useLocation()
    const { section, isOpen, comment } = state

    useEffect(() => {
        if (countryDoc) {
            if (isLoaded(countryDoc)) {
                let countryComments = [...countryDoc.comments]
                countryComments.sort((a, b) => b.date - a.date)
                let commentsPortion = countryComments.slice(0, 10)
                setState(state => ({ ...state, comments: commentsPortion }))
            }
        }
        if (country.capital === 'Athens') { setState({ ...state, capital: 'Atenas', region: 'Europa' }) }
    }, [countryDoc])

    const handleChange = (event) => {
        setState({
            ...state,
            [event.target.name]: event.target.value
        })
    }

    const seeAllComments = () => {
        let countryComments = [...countryDoc[0].comments]
        countryComments.sort((a, b) => b.date - a.date)
        setState({ ...state, comments: countryComments })
    }

    const scrollToRef = (ref) => {
        const desiredTarget = ref.current.offsetTop - 50
        window.scrollTo(0, desiredTarget)
    }

    return (
        <AnimationLayout>
            <motion.div
                className='flex flex-row justify-between items-center flex-wrap pb-5'
            >
                <MatildeBalloon>
                    <p className='text-left'>
                        {countryName}, uma país que gostava de visitar já há um tempo! Todavia, antes de viajar devo me preparar e ter a certeza de que tenho vários recursos na minha mochila e claro, estar bem informada sobre o país em questão!
                    </p>
                </MatildeBalloon>

                <div className='white-container flex flex-col flex-wrap w-full justify-between p-8'>
                    <div className='flex flex-row flex-wrap items-center justify-between'>
                        <div className='flex flex-row items-center'>
                            <img style={{ height: '30px', width: '50px' }} src={country.flag} alt='Bandeira do país' title='Bandeira do país' />
                            <h1 className='pl-4 p-0'>
                                {countryName}
                            </h1>
                        </div>
                        <div>
                            {isCountryFavorite ?
                                <Button className='btn-active mb-2' onClick={() => dispatch(updateFavoriteCountry({ name: countryName }, false))}>
                                    Retirar dos Favoritos
                            </Button>
                                :
                                <Button className='mb-2' onClick={() => dispatch(updateFavoriteCountry({ name: countryName, flag: country.flag }, true))}>
                                    Adicionar aos Favoritos
                            </Button>
                            }
                            <Button onClick={() => scrollToRef(commentsRef)} className="mr-0">Comentários</Button>
                        </div>
                    </div>
                </div>
            </motion.div>

            <motion.div
                id='travels'
                animate={!section
                    ? { opacity: 1, display: 'grid' }
                    : { opacity: 0, display: 'none' }
                }
                className="grid grid-cols-1 gap-8 lg:gap-12 mb-10"
            >
                <div>
                    {chapters.map((item, index) => {
                        const isDone = profile?.travels?.completedTravels.find(travelItem => travelItem === `${countryName} ${chapters[index].link}`)
                        let isLocked = item.file === null ? true : false

                        if (index >= 1) {
                            if (profile?.travels?.completedTravels.find(travelItem => travelItem === `${countryName} ${chapters[index - 1].link}`)) {
                                isLocked = item.file === null ? true : false
                            } else {
                                isLocked = true
                            }
                        }

                        console.log(isLocked)

                        const itemColor = isOpen === item ? '#f6d2b2' : !isLocked ? 'white' : '#b6b6b6'

                        return (
                            <div key={index} className='mb-10'>
                                <motion.div
                                    initial={false}
                                    animate={{ backgroundColor: isOpen === item ? "#f3892e" : "#e4e4e4" }}
                                    onClick={() => {
                                        if (!isLocked) {
                                            setState(isOpen ? { ...state, isOpen: false } : { ...state, isOpen: item })
                                        }
                                    }}
                                    style={{
                                        backgroundImage: `linear-gradient(to left, transparent, ${itemColor} 50%), url(${require(`../assets/img/${item.image}`)})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center"
                                    }}

                                    className={`image-button flex flex-col justify-start text-left mb-8 ${isLocked ? `p-6 md:p-8 disabled` : `px-6 py-8 md:px-8 md:py-10 usable`}`}
                                >
                                    <h2 className='pb-2'>{item.name}</h2>
                                    {isLocked ?
                                        <div>
                                            <p>Capítulo bloqueado*</p>
                                            <p className='text-sm'>* Necessita de concluir o capítulo anterior</p>
                                        </div>
                                        :
                                        <p>{isDone ? 'Capítulo concluído' : 'Capítulo por concluir'}</p>
                                    }
                                    <p>{!item.file && 'Esta narrativa irá estar disponível na versão final do jogo'}</p>

                                </motion.div>

                                <AnimatePresence initial={false}>
                                    {isOpen === item && (
                                        <motion.section
                                            key="content"
                                            animate="open"
                                            exit="collapsed"
                                            className='px-8'
                                            initial="collapsed"
                                            transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
                                            variants={{
                                                open: { opacity: 1, height: "auto" },
                                                collapsed: { opacity: 0, height: 0 }
                                            }}
                                        >
                                            <p>Está prestes a mergulhar num capítulo da viagem ({countryName}) da Matilde e, devido a tal certifica-se de <b>não atualizar a página nem de fechar o navegador</b> de forma a não perder o progresso que alcançou ao longo do capítulo. Fique também atento aos <b>itens que tem na tua mochila</b> para lhe não faltar nada durante a viagem.</p>
                                            <p>Boa sorte e diverta-se!</p>
                                            <div className='flex justify-end'>
                                                <Link to={`${currentLocation.pathname}/${isOpen?.link}`}>
                                                    <Button className='mr-0 mb-2' onClick={() => dispatch(gameActions.makeNarrative(isOpen?.file, isOpen?.link))}>
                                                        Começar
                                                    </Button>
                                                </Link>
                                            </div>
                                        </motion.section>
                                    )}
                                </AnimatePresence>
                            </div>
                        )
                    })}

                </div>
            </motion.div>

            <div ref={commentsRef} className='w-full'>
                <h2>Comentários</h2>

                <MatildeBalloon>
                    <p className='text-left pb-2'>
                        Caso já tenha concluído algumas das viagens e queira contribuir com a sua opinião acerca da experiência comente!
                    </p>
                    <p className='text-left font-medium'>Os comentários não podem possuir símbolos especiais, têm de conter algum conteúdo e não podem ultrapassar as 250 palavras! Para além disso comente sempre com consciência e respeite os outros.</p>
                </MatildeBalloon>

                <div className="mb-4">
                    <label className="block text-gray-700 font-bold mb-2">
                        <span className='pb-2'>Escreva o seu comentário</span>
                        <textarea
                            rows="4"
                            cols="12"
                            name="comment"
                            onChange={handleChange}
                            placeholder="Escreva aqui o contéudo do seu comentário"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 my-3"
                        />
                    </label>
                    <div className='flex justify-end'>
                        <Button className='mr-0' onClick={() => dispatch(setComment(comment, countryName))}>Submeter</Button>
                    </div>
                </div>

                {!isLoaded(countryDoc) ? <Loading /> :
                    countryDoc?.comments && countryDoc?.comments?.length === 0 ?
                        <p className='pb-8'>Este país ainda não recebeu qualquer tipo de comentário! Seja o primeiro a comentar e partilhe a sua experiência nas narrativas ou o porquê de gostar deste país!</p>
                        :
                        <div className="grid grid-cols-1 gap-4 sm:gap-6 md:gap-8 lg:gap-12 pb-8">
                            {updatingReaction ? <Loading /> :
                                countryDoc?.comments && state.comments && state?.comments.map((item, index) => {
                                    let didUserReact = getReactionItems.find(reaction => reaction.id === item.date && reaction.type === 'comments')
                                    let reactionsArray = Object.keys(item.reactions).map((key) => [key, item.reactions[key]])
                                    let reactionsArraySorted = reactionsArray.sort((a, b) => a > b)

                                    return (
                                        <div key={index}>
                                            <li className='grid grid-cols-12 gap-6 lg:gap-8 py-2'>
                                                <Link
                                                    className='col-span-3 lg:col-span-2 flex justify-center items-center'
                                                    to={`perfil/utilizadores/${item?.user}`}
                                                    onClick={() => dispatch(getSpecificUser(item.user))}
                                                >
                                                    <img
                                                        alt={item?.user}
                                                        className='avatar-rounded mr-6'
                                                        src={require(`../assets/img/matilde-faces/${item?.avatar}.png`)}
                                                    />
                                                </Link>
                                                <div className='col-span-9 lg:col-span-6'>
                                                    <h5 className='pb-0'>{item?.name} - {moment(item?.date).fromNow()}</h5>
                                                    <p>{item?.comment}</p>
                                                </div>
                                                <div className='col-span-12 lg:col-span-4 grid grid-cols-4 w-full md:w-auto pt-3 sm:pt-0 gap-4 justify-center items-center'>
                                                    {reactionsArraySorted.map((reactionItem, index) => {
                                                        let activeEmoji = null

                                                        if (didUserReact) {
                                                            activeEmoji = didUserReact?.reaction === reactionItem[0] ? true : null
                                                        }

                                                        return (
                                                            <EmojiButton
                                                                key={index}
                                                                item={item}
                                                                type='comments'
                                                                activeItem={didUserReact}
                                                                isActive={activeEmoji}
                                                                symbol={reactionItem[0]}
                                                                label={reactionItem[0]}
                                                                number={reactionItem[1]}
                                                            />
                                                        )
                                                    })}
                                                </div>
                                            </li>
                                            <hr className='my-4 h-1 bg-gray-400' />
                                        </div>
                                    )
                                })}
                            {countryDoc?.comments > 10 &&
                                <div className='flex justify-end mb-2'>
                                    <Button onClick={() => seeAllComments()} className='mr-0'>Ver todos</Button>
                                </div>
                            }
                        </div>
                }
            </div>

            <Link to='/viajar'>
                <Button className='back-button fixed-go-back rounded-full'>
                    <img src={require('../assets/icons/32/arrow-left-32.png')} alt='olá' />
                </Button>
            </Link>

        </AnimationLayout >
    )
}

export default TravelDestiny